import {Image01Icon} from '@components/ui/icon/Icon.tsx'
import {StyledGalleryItemEmptyPlaceholder} from '@components/commons/gallery-image-item/style.ts'

export const EmptyImagePlaceholder = () => (
    <StyledGalleryItemEmptyPlaceholder>
        <Image01Icon />
    </StyledGalleryItemEmptyPlaceholder>
)
